export default __webpack_public_path__ + "static/media/mini.c4297b6a.webp";